export const COMMUNITY_INFO = {
  title: 'JOIN OUR COMMUNITY',
  subcontent: 'You seem a little SUS 🧐, perfectttt!!! Join our community today where you will find like-minded, kinda-sus individuals like yourself. <br><br>Start to read your opponents and get a feel of your fellow Impostors to identify the backstabbers 🔪!',
  discordLink: 'https://discord.gg/ghv8vjj52D'
};
